import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import { Error, typographyClassName } from './typography';

type Props = HTMLAttributes<HTMLTextAreaElement> & {
  value: string | null | undefined;
  onValueChange: (val: string) => void;
  error?: string;
  disabled?: boolean;
};

const Textarea: React.FC<Props> = ({
  value,
  onValueChange,
  error,
  disabled,
  className,
  ...props
}) => (
  <div>
    <textarea
      {...props}
      disabled={disabled}
      rows={3}
      className={clsx(
        typographyClassName,
        'form-control m-0 block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding p-[8px] transition ease-in-out focus:border-blue-600 focus:bg-white focus:text-gray-700 focus:outline-none',
        className,
      )}
      value={value ?? undefined}
      onChange={(e) => onValueChange(e.target.value)}
    />
    {error && <Error>{error}</Error>}
  </div>
);

Textarea.displayName = 'Textarea';

export default Textarea;
